export const useLanguages = () => {
  const languageLabel = (locale: string, code?: string): string => {
    if (!code) return '-'

    try {
      const displayNames = new Intl.DisplayNames([locale], { type: 'language' })
      const label = displayNames.of(code.toLowerCase()) ?? code

      return label.charAt(0).toUpperCase() + label.slice(1)
    } catch {
      return code
    }
  }

  return { languageLabel }
}
